import { format, isValid } from 'date-fns';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone.js';
import { convertOffsetToHours } from './timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const geDateTimeInTimezone = (
  date: string | null,
  timezone: string | null,
) => {
  return dayjs
    .utc(date)
    .add(Number(convertOffsetToHours(timezone ?? '+00:00')), 'hour');
};

export const getDateTimeInUTC = (date: string | null, timezone: string) => {
  return dayjs
    .utc(date)
    .add(-Number(convertOffsetToHours(timezone ?? '+00:00')), 'hour');
};

export const formatDate = (
  value?: string | Date | null,
  pattern = 'MMM d, yyyy',
): string => {
  const date = value ? new Date(value) : null;

  return date && isValid(date) ? format(date, pattern) : '';
};

const pad = (value: number): string => {
  return value < 10 ? '0' + value : value.toString();
};

export const getUserOffset = (): string => {
  const date = new Date();
  const sign = date.getTimezoneOffset() > 0 ? '-' : '+';
  const offset = Math.abs(date.getTimezoneOffset());
  const hours = pad(Math.floor(offset / 60));
  const minutes = pad(offset % 60);
  return sign + hours + ':' + minutes;
};
